import React from "react";
import { useTranslation } from "react-i18next";
import tailwindClassnames from "../common/TailwindClassnames";

type OrganizationDetailsProps = {
  orgName: string;
  perms: any[];
  existingOrganization: boolean;
  subPage: string | undefined;
  onSelectSubPage: Function;
};

const OrganizationDetails: React.FC<OrganizationDetailsProps> = ({
  orgName,
  perms,
  existingOrganization,
  subPage,
  onSelectSubPage,
}) => {
  const tabStyle = "cursor-pointer py-2 px-4 text-sm font-medium text-center";
  const { t } = useTranslation();

  return (
    <div className="flex flex-row w-full">
      <div className="overflow-x-auto w-full mt-8">
        <div className={tailwindClassnames.pageHeaderRow}>
          <h1 className={tailwindClassnames.pageTitle}>
            {existingOrganization ? orgName : t("New Organization")}
          </h1>
        </div>
        {existingOrganization && (
          <div className="">
            <div className="border border-primary-off-white dark:border-storm-blue-dark border-b-storm-blue-light dark:border-b-sky-blue transition duration-300">
              <div className="flex flex-row">
                <button
                  className={`${tabStyle} ${
                    subPage === "overview"
                      ? `${tailwindClassnames.detailsActiveTab}`
                      : `${tailwindClassnames.detailsInactiveTab}`
                  }`}
                  onClick={() => onSelectSubPage("overview")}
                >
                  {t("Organization Details")}
                </button>
                {perms.some(
                  (permission) =>
                    permission.name === "VIEW_USER_DETAILS_IN_ORG",
                ) && (
                  <button
                    className={`${tabStyle} ${
                      subPage === "users"
                        ? `${tailwindClassnames.detailsActiveTab}`
                        : `${tailwindClassnames.detailsInactiveTab}`
                    }`}
                    onClick={() => onSelectSubPage("users")}
                  >
                    {t("Users")}
                  </button>
                )}
                <button
                  className={`${tabStyle} ${
                    subPage === "projects"
                      ? `${tailwindClassnames.detailsActiveTab}`
                      : `${tailwindClassnames.detailsInactiveTab}`
                  }`}
                  onClick={() => onSelectSubPage("projects")}
                >
                  {t("Projects")}
                </button>
                <button
                  className={`${tabStyle} ${
                    subPage === "sensors"
                      ? `${tailwindClassnames.detailsActiveTab}`
                      : `${tailwindClassnames.detailsInactiveTab}`
                  }`}
                  onClick={() => onSelectSubPage("sensors")}
                >
                  {t("Sensors")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationDetails;
